import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"

export type ExitCheckOrder = {
  orderId: number
  date: string
  tableNumber?: number | null
  totalFinal: number
  description?: string | null
}

export type ExitCheckResponse = {
  customerFound: boolean
  customerId: number
  customerName: string
  cpf: string
  hasActiveDebit: boolean
  totalDebit: number
  activeDebitOrders: ExitCheckOrder[]
}

export const useCheckCustomerExit = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const { enableLoad, disableLoad } = useLoad()

  const handleCheckCustomerExit = async (cpf: string, onSuccess: (data: ExitCheckResponse | null) => void) => {
    enableLoad()

    try {
      const params = new URLSearchParams()
      params.append("cpf", cpf)

      const response = await GetRequest<ExitCheckResponse>(`${API_ROUTES.CUSTOMER.EXIT_CHECK}?${params.toString()}`)

      if (response.success) {
        onSuccess(response.data ?? null)
        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      onSuccess(null)

      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleCheckCustomerExit,
  }
}
